<div class="pdf-viewer-wrapper">
    <div class="viewer-container" #viewerContainer>
      <div id="viewer" class="pdfViewer"></div>
    </div>
  </div>
  